export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_-JavaScript_section_02-468c5b777d9084fbed25f49961d85ee5.jpg";